(() => {
  function init(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const form = root.querySelector('form');
    if (!form) return;
    const measures = [...form.querySelectorAll('[data-measure]')];
    const update = () => {
      const overflow = form.querySelector('#AE-pool_type')?.value === 'Überlaufbecken';
      const overflowWarning = root.querySelector('[data-overflow-warning]');
      if (overflowWarning) overflowWarning.hidden = !overflow;
      const initial = form.querySelector('[data-model]:checked')?.value === 'INITIAL';
      const ladder = form.querySelector('#AE-ladder')?.value === 'Ja';
      const warning = root.querySelector('[data-model-warning]');
      if (warning) warning.hidden = !(initial && ladder);
      for (const field of measures) {
        const number = Number(field.value.replace(',', '.'));
        field.setCustomValidity(field.value && (!(number > 0) || number > 50) ? root.dataset.invalidMeasure : '');
      }
    };
    form.addEventListener('input', update);
    form.addEventListener('change', update);
    form.addEventListener('submit', event => {
      update();
      if (!form.checkValidity()) {
        event.preventDefault();
        form.reportValidity();
        return;
      }
      const button = form.querySelector('[type="submit"]');
      if (button) {
        button.setAttribute('aria-busy', 'true');
        button.textContent = button.dataset.submittingLabel;
      }
    });
    window.addEventListener('pageshow', () => {
      const button = form.querySelector('[type="submit"]');
      if (button) {
        button.removeAttribute('aria-busy');
        button.textContent = button.dataset.submitLabel;
      }
    });
    update();
  }
  document.querySelectorAll('[data-ap-enquiry]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-ap-enquiry]').forEach(init));
})();

